import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {OrderRequestCancellationCodeResultModel} from "../../models/order-request-cancellation-code-result-model";
import {OrderRequestCancellationCodeModel} from "../../models/order-request-cancellation-code-model";
import {ResponseCancellationModel} from "../../models/response-cancellation-model";

@Injectable({
  providedIn: 'root'
})
export class OrderCancellationService {

  readonly apiPath = 'order-cancellation/';
  readonly headers = new HttpHeaders({ 'No-Auth': 'True' });

  constructor(
      private http: HttpClient,
  ) { }



  submitCancellationDetails(token: string, model: OrderRequestCancellationCodeModel): Observable<any> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath + 'cancellation-details', model, { params, headers: this.headers });
  }

  requestCancellation(token: string): Observable<ResponseCancellationModel> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath, null, { params, headers: this.headers }) as Observable<ResponseCancellationModel>;
  }
  requestCancellationVerificationCode(token: string): Observable<any> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath + 'request-code', null, { params, headers: this.headers });
  }
  confirmCancellationVerificationCode(token: string, model: OrderRequestCancellationCodeModel): Observable<OrderRequestCancellationCodeResultModel> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath + 'verify-code', model, { params, headers: this.headers }) as Observable<OrderRequestCancellationCodeResultModel>;
  }


  changeMobilephoneNumber(token: string, item): Observable<string> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath + 'change-number', item, { params, headers: this.headers }) as Observable<string>;
  }

  confirmCancellationByEmail(token: string): Observable<any> {
    const params = new HttpParams().append('token', token);
    return this.http.post(this.apiPath + 'confirm', null, { params, headers: this.headers });
  }
}


